const AMPLITUDE_DEVICE_ID_STORAGE_KEY = 'uplisting:amplitude-device-id';

export function storeAmplitudeDeviceId(deviceId: string | undefined): void {
  if (!deviceId) {
    return;
  }

  try {
    window.localStorage.setItem(AMPLITUDE_DEVICE_ID_STORAGE_KEY, deviceId);
  } catch {
    return;
  }
}

export function getStoredAmplitudeDeviceId(): string | undefined {
  try {
    return (
      window.localStorage.getItem(AMPLITUDE_DEVICE_ID_STORAGE_KEY) ?? undefined
    );
  } catch {
    return undefined;
  }
}

export function clearStoredAmplitudeDeviceId(): void {
  try {
    window.localStorage.removeItem(AMPLITUDE_DEVICE_ID_STORAGE_KEY);
  } catch {
    return;
  }
}

export function applyStoredAmplitudeDeviceId(): void {
  const storedDeviceId = getStoredAmplitudeDeviceId();
  const instance = window.amplitude?.getInstance?.();

  if (!storedDeviceId || !instance) {
    return;
  }

  if (instance.options?.deviceId !== storedDeviceId) {
    instance.setDeviceId?.(storedDeviceId);
  }
}

function getAmplitudeDeviceId(): string | undefined {
  return (
    getStoredAmplitudeDeviceId() ??
    window.amplitude?.getInstance?.()?.options?.deviceId
  );
}

const TOP_LEVEL_SECTIONS: Record<string, string> = {
  dashboard: 'Dashboard',
  monthly: 'Monthly',
  calendar: 'Calendar',
  xcalendar: 'Calendar',
  action: 'Calendar',
  clients: 'Clients',
  automate: 'Automate',
  connect: 'Connect',
  direct: 'Direct Booking',
  'ai-messaging': 'AI Messaging',
  outbound: 'Outbound',
  insights: 'Insights',
  reports: 'Reports',
  account: 'Account',
  notifications: 'Notifications',
  upsells: 'Upsells',
  register: 'Auth',
  signup: 'Auth',
  logout: 'Auth',
  'auth-callback': 'Auth',
};

export function getScreenSection(routeName: string): string {
  if (routeName.includes('.properties.pricing')) {
    return 'Pricing';
  }

  if (routeName.includes('.properties.channels')) {
    return 'Channels';
  }

  if (routeName.includes('.properties')) {
    return 'Properties';
  }

  if (routeName.includes('.inbox')) {
    return 'Inbox';
  }

  const topLevel = routeName.split('.')[0] ?? '';

  return TOP_LEVEL_SECTIONS[topLevel] ?? topLevel;
}

export function onAnalyticsReady(cb: () => void): void {
  if (window.analytics?.ready) {
    let isCalled = false;

    window.analytics.ready(() => {
      isCalled = true;

      cb();
    });

    window.setTimeout(() => {
      if (!isCalled) {
        cb();
      }
    }, 1_000);
  } else {
    cb();
  }
}

export function openPageWithAmplitudeDeviceId(page: string): void {
  onAnalyticsReady(() => {
    const deviceId = getAmplitudeDeviceId();
    const url = new URL(page);

    if (deviceId !== undefined) {
      url.searchParams.append('amp_device_id', deviceId);
    }

    window.open(url.href, '_self');
  });
}
